<template>
  <v-container class="cmp-settings-label-settings dt-sidewindow submodule-root">
    <div class="dt-tabs-container submodule-root">
      <glayout :tabs="labelSettingsTabs" tabPanelColor="secondary">
        <gtab>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    labelSettingsData &&
                      labelSettingsData.formats &&
                      labelSettingsData.formats.length
                  )
                "
                :title="$t('format')"
                :loading="labelSettingsData.label_setting_loading"
              >
                <FormatTable
                  v-if="labelSettingsData"
                  @add_click="onFormatAddClick"
                  @selected="onFormatSelect"
                  @deleted="onFormatDelete"
                  @changed="onFormatChange"
                  :formats="labelSettingsData ? labelSettingsData.formats : []"
                />
                <!-- <DTable
                  :linkLabelName="`${$t('add')} ${$t('format')}`"
                  :items="labelSettingsData ? labelSettingsData.formats : []"
                  :headers="formatsHeaders"
                  :showHeader="true"
                  :itemName="'format'"
                  :primaryKey="'format_id'"
                  @add_click="onFormatAddClick"
                  @changed="onFormatChange"
                  @selected="onFormatSelect"
                  @deleted="onFormatDelete"
                /> -->
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    labelSettingsData &&
                      labelSettingsData.product_types &&
                      labelSettingsData.product_types.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('categories')"
                :loading="labelSettingsData.label_setting_loading"
              >
                <DBox
                  :id="'cmp-settings-booking-travel-options'"
                  :addButton="false"
                  :addLink="true"
                  :addLinkLabel="`${$t('add')} ${$t('category')}`"
                  @add_click="onProductTypeAddClick"
                >
                  <DList
                    v-if="labelSettingsData"
                    :items="labelSettingsData.product_types"
                    :clickable="true"
                    :primaryKey="'product_type_id'"
                    :labelKey="'product_type_name'"
                    @delete="onProductTypeDelete"
                    @item_click="onProductTypeClick"
                  />
                </DBox>
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    labelSettingsData &&
                      labelSettingsData.media_types &&
                      labelSettingsData.media_types.length
                  )
                "
                :title="$t('media_types')"
                :loading="labelSettingsData.label_setting_loading"
              >
                <DTable
                  :linkLabelName="`${$t('add')} ${$t('media_type')}`"
                  :items="
                    labelSettingsData ? labelSettingsData.media_types : []
                  "
                  :headers="
                    dHeaders([
                      {
                        text: 'media_types',
                        value: 'mechanical_name',
                        selectable: true,
                      },
                      { text: 'no', value: 'mechanical_no' },
                    ])
                  "
                  :showHeader="true"
                  :itemName="'media'"
                  :primaryKey="'media_id'"
                  @add_click="onMediaTypeAddClick"
                  @selected="onMediaTypeSelect"
                  @deleted="onMediaTypeDelete"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="pricing" :title="$t('pricing')">
          <grow>
            <gcol>
              <gbox
                :loading="labelSettingsData.label_setting_loading"
                :h="
                  boxHeight(
                    labelSettingsData &&
                      labelSettingsData.price_lists &&
                      labelSettingsData.price_lists.length
                  )
                "
                :title="$t('price_lists')"
              >
                <DTable
                  :linkLabelName="`${$t('add')} ${$t('price_list')}`"
                  :items="
                    labelSettingsData ? labelSettingsData.price_lists : []
                  "
                  :headers="
                    dHeaders([
                      {
                        text: 'price_lists',
                        value: 'price_list_name',
                        selectable: true,
                        f: 2,
                      },
                      { text: 'currency', value: 'currency_name', f: 1 },
                    ])
                  "
                  :showHeader="true"
                  :itemName="'price_list'"
                  :primaryKey="'price_list_id'"
                  @add_click="onPriceListAddClick"
                  @changed="onPriceListChange"
                  @selected="onPriceListSelect"
                  @deleted="onPriceListDelete"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :loading="labelSettingsData.label_setting_loading"
                :h="
                  boxHeight(
                    labelSettingsData &&
                      labelSettingsData.price_codes &&
                      labelSettingsData.price_codes.length
                  )
                "
                :title="$t('price_codes')"
              >
                <DTable
                  :linkLabelName="`${$t('add')} ${$t('pricecode')}`"
                  :items="
                    labelSettingsData ? labelSettingsData.price_codes : []
                  "
                  :headers="
                    dHeaders([
                      {
                        text: 'price_codes',
                        value: 'price_code_name',
                        selectable: true,
                      },
                      {
                        text: 'description',
                        value: 'price_code_description',
                      },
                    ])
                  "
                  :showHeader="true"
                  :itemName="'price_code'"
                  :primaryKey="'price_code_id'"
                  @add_click="onPriceCodeAddClick"
                  @selected="onPriceCodeSelect"
                  @deleted="onPriceCodeDelete"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="additional_info">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    labelSettingsData &&
                      labelSettingsData.label_statuses &&
                      labelSettingsData.label_statuses.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('label_status')"
                :loading="labelSettingsData.label_statuses_loading"
              >
                <LabelStatuses
                  v-if="labelSettingsData"
                  :statuses="labelSettingsData.label_statuses"
                  @color_changed="onColorChange"
                  @added="onLabelStatusAddClick"
                  @deleted="onLabelStatusDeleteClick"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    labelSettingsData &&
                      labelSettingsData.licence_statuses &&
                      labelSettingsData.licence_statuses.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('licencing_status')"
                :loading="labelSettingsData.licence_statuses_loading"
              >
                <DBox
                  :id="'cmp-settings-accounting-money-accounts'"
                  :addButton="false"
                  :addLink="true"
                  :addLinkLabel="`${$t('add')} ${$t('licencing_status')}`"
                  @add_click="onAddLicenceAccount"
                >
                  <DList
                    v-if="labelSettingsData"
                    :items="labelSettingsData.licence_statuses"
                    :primaryKey="'licence_status_id'"
                    :labelKey="'licence_status_text'"
                    :clickable="true"
                    @delete="onLicenceStatusDelete"
                    @item_click="onLicenceStatusClick"
                  />
                </DBox>
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    labelSettingsData &&
                      labelSettingsData.shipping_types &&
                      labelSettingsData.shipping_types.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('shipping_types')"
                :loading="labelSettingsData.shipping_types_loading"
              >
                <ShippingTypes
                  v-if="labelSettingsData"
                  :shipping_types="labelSettingsData.shipping_types"
                  @deleted="onShippingTypeDelete"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    labelSettingsData &&
                      labelSettingsData.marketing_types &&
                      labelSettingsData.marketing_types.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('marketing_types')"
                :loading="labelSettingsData.marketing_types_loading"
              >
                <DTable
                  :linkLabelName="`${$t('add')} ${$t('marketing_type_string')}`"
                  :items="
                    labelSettingsData ? labelSettingsData.marketing_types : []
                  "
                  :headers="[]"
                  :itemName="$t('income_group')"
                  :primaryKey="'marketing_type_id'"
                  :labelKey="''"
                  :fieldKey="'marketing_type_name'"
                  :fieldPlaceholder="'Name'"
                  @add_click="onMarketingTypeAddClick"
                  @changed="onMarketingTypeChange"
                  @deleted="onMarketingTypeDelete"
                />
              </gbox>
              <!-- <gbox
                v-if="$store.getters.believe_special"
                :h="
                  boxHeight(
                    labelSettingsData &&
                      labelSettingsData.deal_types &&
                      labelSettingsData.deal_types.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('deal_types_string')"
                :loading="labelSettingsData.deal_types_loading"
              >
                <DTable
                  :linkLabelName="`${$t('add')} ${$t('deal_type')}`"
                  :items="labelSettingsData ? labelSettingsData.deal_types : []"
                  :headers="[]"
                  :itemName="$t('income_group')"
                  :primaryKey="'deal_type_id'"
                  :labelKey="'deal_type_name'"
                  :fieldKey="'deal_type_code'"
                  :fieldPlaceholder="'Code'"
                  :fieldEditable="false"
                  @add_click="onDealTypeAddClick"
                  @changed="onDealTypeChange"
                  @selected="onDealTypeSelected"
                  @deleted="onDealTypeDeleted"
                />
              </gbox> -->
              <!-- <gbox
                v-if="$store.getters.believe_special"
                :h="
                  boxHeight(
                    labelSettingsData &&
                      labelSettingsData.advance_types &&
                      labelSettingsData.advance_types.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('advanced_types')"
                :loading="labelSettingsData.advance_types_loading"
              >
                <DBox
                  :id="'cmp-settings-label-advance_types'"
                  :addButton="false"
                  :addLink="true"
                  :addLinkLabel="`${$t('add')} ${$t('advance_type')}`"
                  @add_click="onAdvanceTypeAddClick"
                >
                  <DList
                    v-if="labelSettingsData"
                    :items="labelSettingsData.advance_types"
                    :primaryKey="'advance_type_id'"
                    :labelKey="'advance_type_name'"
                    :clickable="true"
                    @delete="onAdvanceTypeDelete"
                    @item_click="onAdvanceTypeClick"
                  />
                </DBox>
              </gbox> -->
            </gcol>
          </grow>
        </gtab>
        <gtab id="api_configs" :title="$t('api_configs')">
          <template #header>
            <grow>
              <gcol>
                <div class="ut-flex">
                  <button
                    style="margin-left: 0px"
                    class="dt-button dt-button v5 s8"
                    @click="onAddAPIConfigClick"
                  >
                    {{ $t("add") }} {{ $t("api_config") }}
                  </button>
                </div>
              </gcol>
            </grow>
          </template>
          <grow>
            <template
              v-for="(apiFormCol, index) of splitEvery(
                apiFormsSplitLength,
                nonEmptyApiForms
              )"
            >
              <gcol :key="index">
                <template v-for="apiForm of apiFormCol">
                  <template
                    v-if="apiForm.formData && apiForm.formData.length > 0"
                  >
                    <gbox
                      :title="snakeCaseToWords(apiForm.form_name)"
                      :key="apiForm.form_name"
                    >
                      <DBox
                        :id="'cmp-api-configs'"
                        :addButton="false"
                        :addLink="true"
                        :addLinkLabel="`${$t('add')} ${snakeCaseToWords(
                          apiForm.form_name
                        )} ${$t('api_config')}`"
                        @add_click="
                          (e) => onAddFormItemClick(apiForm.form_name)
                        "
                      >
                        <div
                          class="api-item"
                          v-for="(fd, index) of apiForm.formData"
                          :key="index"
                          :class="{
                            minimized: isMinimized(apiForm.form_name, index),
                          }"
                        >
                          <div
                            class="api-item-title-bar ut-flex ut-jbetween ut-pl-10px"
                          >
                            <div class="api-title ut-fb">
                              {{ snakeCaseToWords(apiForm.form_name) }}
                              {{ index + 1 }}
                            </div>
                            <div class="api-options ut-flex">
                              <div class="dt-icon-container s30">
                                <img
                                  :src="
                                    isMinimized(apiForm.form_name, index)
                                      ? `static/icons/plus.svg`
                                      : `static/icons/minus.svg`
                                  "
                                  class="dt-icon v5 s1"
                                  @click="
                                    (e) =>
                                      onMinimizeAPIItem(
                                        apiForm.form_name,
                                        index
                                      )
                                  "
                                  :alt="$t('minimize_api_item')"
                                  :title="$t('minimize_api_item')"
                                />
                              </div>
                              <div class="dt-icon-container s30">
                                <img
                                  src="static/icons/delete.svg"
                                  class="dt-icon v5 s1"
                                  @click="
                                    (e) =>
                                      onDeleteAPIItem({
                                        form_name: apiForm.form_name,
                                        item: fd,
                                      })
                                  "
                                  :alt="$t('delete_item')"
                                  :title="$t('delete_item')"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="api-item-form"
                            :style="{
                              height: isMinimized(apiForm.form_name, index)
                                ? '0px'
                                : maximizedHeight(apiForm, index),
                              transition: 'height 200ms ease-out',
                              overflow: 'hidden',
                            }"
                          >
                            <DynamicForm
                              :forms="apiForm.form"
                              :formsData="fd"
                              :textFieldConfig="textFieldConfig"
                              :version="2"
                              @changed="
                                ({ name, value }) =>
                                  onDynamicFormChange({
                                    name,
                                    value,
                                    form_name: apiForm.form_name,
                                    index,
                                  })
                              "
                              @validated="
                                ({ name, value }) =>
                                  onDNValidated({
                                    name,
                                    value,
                                    form_name: apiForm.form_name,
                                    index,
                                  })
                              "
                            />
                          </div>
                        </div>
                      </DBox>
                    </gbox>
                  </template>
                </template>
              </gcol>
            </template>
          </grow>
        </gtab>
        <gtab id="mechanicals" :title="$t('mechanicals')">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    labelSettingsData &&
                      labelSettingsData.rates &&
                      labelSettingsData.rates.length
                  )
                "
                :title="$t('mechanical')"
                :loading="labelSettingsData.rates_loading"
              >
                <MechanicalRatesHome
                  v-if="labelSettingsData"
                  :rates="labelSettingsData.rates || []"
                  @added="onMechanicalRateAdd"
                  @changed="onMechanicalRateChange"
                  @deleted="onMechanicalRateDelete"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab
          v-for="tab in taskTable"
          :id="tab == 'contract' ? `tasks_${tab}` : `tasks_${tab}s`"
          :key="tab"
        >
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    labelSettingsData &&
                      labelSettingsData[`${tab}_task_templates`] &&
                      labelSettingsData[`${tab}_task_templates`].length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('tab_title_tasks')"
              >
                <SettingsTaskTemplates
                  v-if="labelSettingsData"
                  :settingsData="labelSettingsData"
                  :externalTable="tab"
                />
                <!-- @add_click="onTaskTemplateAddClick"
                  @delete="onTaskTemplateDeleted" -->
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    labelSettingsData &&
                      labelSettingsData[`${tab}_task_template_groups`] &&
                      labelSettingsData[`${tab}_task_template_groups`].length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('task_template_group')"
              >
                <SettingsTaskTemplateGroups
                  v-if="labelSettingsData"
                  :settingsData="labelSettingsData"
                  :externalTable="tab"
                  @add_click="onTemplateTaskGroupAddClick"
                />
                <!-- @selected="onTaskTemplateGroupSelected"
                  @delete="onTaskTemplateGroupDeleted"
                  @updated="onTaskTemplateGroupUpdated"
                  @add_click="onTemplateTaskGroupAddClick" -->
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('task_template_group_items')">
                <SettingsTaskGroupItem
                  :externalTable="tab"
                  :settingsData="labelSettingsData"
                  v-if="labelSettingsData"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
    <ModalContainer :modalKey="'editStatus'" :width="'small'">
      <LabelStatusForm
        @edited="onLabelStatusEdited"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addStatus'" :width="'small'">
      <LabelStatusForm
        @added="onLabelStatusAdded"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'editShippingType'" :width="'small'">
      <QuickModal
        :title="$t('edit') + ' ' + $t('shipping_type')"
        :forms="shippingTypeForm"
        :formData="shippingTypeFormData"
        @cancelled="onModalCancelled"
        @ok="onShippingTypeEdited"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addShippingType'" :width="'small'">
      <QuickModal
        :title="$t('add') + ' ' + $t('shipping_type')"
        :forms="shippingTypeForm"
        @cancelled="onModalCancelled"
        @ok="onShippingTypeAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'formatForm'" :width="'small'">
      <FormatForm @done="formatSubmitted" @cancelled="onModalCancelled" />
    </ModalContainer>
    <ModalContainer :modalKey="'productTypeForm'" :width="'small'">
      <ProductTypeForm
        @done="productTypeSubmitted"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'priceListForm'" :width="'small3'">
      <PriceListForm @done="priceListSubmitted" @cancelled="onModalCancelled" />
    </ModalContainer>
    <ModalContainer :modalKey="'mediaTypeForm'" :width="'small'">
      <MediaTypeForm @done="onMediaTypeSubmit" @cancelled="onModalCancelled" />
    </ModalContainer>
    <ModalContainer :modalKey="'priceCodeForm'" :width="'medium'">
      <PriceCodeForm @done="onPriceCodeSubmit" @cancelled="onModalCancelled" />
    </ModalContainer>
    <ModalContainer :modalKey="'addConfig'" :width="'small'">
      <AddConfig
        :labelSettingsData="labelSettingsData"
        :apiForms="apiForms"
        @added="onAPIAdd"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'addLicenceStatus'" :width="'small'">
      <QuickModal
        :title="$t('add_new_licence_status')"
        :placeholder="$t('licence_status_name')"
        @cancelled="onModalCancelled"
        @ok="onNewLicenceStatusAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'editLicenceStatus'" :width="'small'">
      <QuickModal
        :value="licenceStatusText"
        :title="$t('edit_new_licence_status')"
        :placeholder="$t('licence_status_name')"
        @cancelled="onModalCancelled"
        @ok="onLicenceStatusEdited"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'addDealType'" :width="'small'">
      <QuickModal
        :title="$t('add_new_deal_type')"
        :forms="dealTypeForm"
        :formData="dealTypeFormData"
        @cancelled="onModalCancelled"
        @ok="onNewDealTypeAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'editDealType'" :width="'small'">
      <QuickModal
        :title="$t('edit_deal_type')"
        :forms="dealTypeForm"
        :formData="dealTypeFormData"
        @cancelled="onModalCancelled"
        @ok="onDealTypeEdited"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'addAdvanceType'" :width="'small'">
      <QuickModal
        :title="$t('add_new_advance_type')"
        :placeholder="$t('advance_type_name')"
        @cancelled="onModalCancelled"
        @ok="onNewAdvanceTypeAdd"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'editAdvanceType'" :width="'small'">
      <QuickModal
        :value="advance_type_name"
        :title="$t('edit_new_advance_type')"
        :placeholder="$t('advance_type_name')"
        @cancelled="onModalCancelled"
        @ok="onAdvanceTypeEdit"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import DBox from "@dtplugins/dbox/dbox";
import DList from "@dtplugins/list/dlist";
import * as ActionTypes from "../../store/types";
import { mapKeyToAction, mapActionObject } from "../../../../store/global";
import { SettingsStoreNamespace as storeNS } from "../../store";
import { mapGetters } from "vuex";
import {
  createModalMixin,
  closeModalRoute,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import QuickModal from "@plugins/quickmodal/quickmodal";
import { createFields } from "../../../../plugins/quickmodal";
import ModalContainer from "@dtplugins/modal/modal-container";
import {
  createTextFieldConfig,
  createValidator,
  EventHooks,
} from "../../../../plugins/text-field";
import { JSONX, snakeCaseToWords, wait } from "../../../../utility";
import { LoadingUI } from "@plugins/loading/loading";
import {
  NotificationService,
  showError,
  showNotification,
} from "../../../../dt-plugins/notification/notification.service";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import DTable from "@dtplugins/dtable/dtable";
import NTable from "@/plugins/datatable/datatable";
import Ddropzone from "@dtplugins/dbox/dropzone";
import { labelSettingsActions } from "../../store/label/actions";
import { dHeaders, DHeaderTypes } from "../../../../dt-plugins/dtable";

import FormatForm from "./format-form";
import ProductTypeForm from "./product-type-form";
import PriceListForm from "./price-list-form";
import MediaTypeForm from "./media-type-form";
import PriceCodeForm from "./price-code-form";
import APIConfigs from "./api-configs";
import AddConfig from "./add-config";
import ApiKey from "./api-key";
import LabelStatuses from "./label-statuses";
import FormatTable from "./format-table.vue";
import ShippingTypes from "./shipping-types";
import { isNegative } from "../../../../utility/fp";
import {
  createForms,
  createForm,
} from "../../../../plugins/form-builder/form.model";
import { clientName } from "../../../../services/http/http-client";
import LabelStatusForm from "./label-status-form";
import MechanicalRatesHome from "./mechanical-rates-home";
import DynamicForm from "@plugins/form-builder/dynamic-form";
import { set, lensPath, fromPairs, toPairs, splitEvery } from "ramda";
import { createTV } from "../../../../models/text-value.model";
import SettingsTaskTemplateGroups from "../settings-plugins/settings-task-template-groups.vue";
import SettingsTaskTemplates from "../settings-plugins/settings-task-templates.vue";
import SettingsTaskGroupItem from "../settings-plugins/settings-task-group-item.vue";
export default {
  components: {
    DBox,
    DList,
    DTable,
    QuickModal,
    ModalContainer,
    LoadingUI,
    NTable,
    Ddropzone,

    FormatForm,
    ProductTypeForm,
    PriceListForm,
    MediaTypeForm,
    PriceCodeForm,
    APIConfigs,
    AddConfig,
    ApiKey,
    LabelStatuses,
    ShippingTypes,
    LabelStatusForm,
    MechanicalRatesHome,
    DynamicForm,
    SettingsTaskTemplateGroups,
    SettingsTaskTemplates,
    SettingsTaskGroupItem,
    FormatTable,
  },
  mounted: function () {
    this.fetchData();
  },
  data: function () {
    return {
      textFieldConfig: createTextFieldConfig({
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        valueChangedEvent: EventHooks.OnBlur,
      }),

      selectedTaxGroup: null,
      clientName: clientName,

      taskTable: ["licence", "release", "product", "contract"],

      //API Config Data
      formData: null,
      minimizedFormItems: [],
    };
    //MARK: Data Function
  },
  watch: {
    labelSettingsData: {
      immediate: true,
      handler: function (newValue, oldValue) {
        this.formData = newValue;
      },
    },
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("editStatus"),
    createModalMixin("addStatus"),
    createModalMixin("editShippingType"),
    createModalMixin("addShippingType"),
    createModalMixin("formatForm"),
    createModalMixin("productTypeForm"),
    createModalMixin("priceListForm"),
    createModalMixin("mediaTypeForm"),
    createModalMixin("priceCodeForm"),
    createModalMixin("addConfig"),
    createModalMixin("addLicenceStatus"),
    createModalMixin("editLicenceStatus"),
    createModalMixin("addDealType"),
    createModalMixin("editDealType"),

    createModalMixin("addAdvanceType"),
    createModalMixin("editAdvanceType"),
  ],
  computed: {
    ...mapGetters(storeNS, {
      labelSettingsData: "labelSettingsData",
    }),
    labelSettingsTabs: function () {
      return [
        {
          route: "overview",
          value: this.$t("tab_title_label_settings"),
        },
        {
          route: "pricing",
          value: this.$t("pricing"),
        },
        {
          route: "additional_info",
          value: this.$t("additional_infos"),
        },
        {
          route: "api_configs",
          value: this.$t("api_configs"),
        },
        {
          route: "mechanicals",
          value: "mechanicals",
        },
        // {
        //   route: "tasks_licences",
        //   value: this.$t("tasks_licences"),
        // },
        // {
        //   route: "tasks_releases",
        //   value: this.$t("tasks_releases"),
        // },
        // {
        //   route: "tasks_products",
        //   value: this.$t("tasks_products"),
        // },
        // {
        //   route: "tasks_contract",
        //   value: this.$t("tasks_contract"),
        // },
      ];
    },
    formatsHeaders: function () {
      return dHeaders([
        {
          text: "format",
          value: "format_name",
          type: DHeaderTypes.Text,
          selectable: true,
        },
        {
          text: "album",
          value: "album_single_merch",
          type: DHeaderTypes.Text,
          selectable: false,
        },
        {
          text: "2_sides",
          value: "two_sides_flag",
          ta: "center",
          type: DHeaderTypes.Checkbox,
          selectable: false,
          mw: "100",
        },
        {
          text: "group",
          value: "format_group",
          type: DHeaderTypes.TextField,
          selectable: false,
          placeholder: this.$t("group"),
        },
      ]);
    },
    licenceStatusText: function () {
      return this.$route.query.licence_status_text || "";
    },
    dealTypeForm: function () {
      return createForms([
        createForm({
          required: true,
          name: "deal_type_name",
          showValidationIcons: true,
        }),
        createForm({
          required: true,
          name: "deal_type_code",
          showValidationIcons: true,
        }),
      ]);
    },
    dealTypeFormData: function () {
      return {
        deal_type_id: this.$route.query.deal_type_id,
        deal_type_code: this.$route.query.deal_type_code,
        deal_type_name: this.$route.query.deal_type_name,
      };
    },
    shippingTypeForm: function () {
      return createForms([
        createForm({
          required: true,
          name: "shipping_type",
          showValidationIcons: true,
        }),
        createForm({
          required: false,
          name: "service_code",
          showValidationIcons: false,
        }),
      ]);
    },
    shippingTypeFormData: function () {
      return {
        shipping_type_id: this.$route.query.shipping_type_id,
        shipping_type: this.$route.query.shipping_type,
        service_code: this.$route.query.service_code,
      };
    },
    advance_type_name: function () {
      return this.$route.query.advance_type_name || "";
    },
    advance_type_id: function () {
      return this.$route.query.advance_type_id || "";
    },

    // API Config Data
    formsData: function () {
      return {};
    },
    apiForms: function () {
      const aForms = Object.keys(
        this.labelSettingsData?.translator_api_configs_structure || {}
      )
        .sort()
        .map((formKey) => {
          const formData =
            this.labelSettingsData?.translator_api_configs?.[formKey];
          return {
            form_name: formKey,
            form: this.labelSettingsData?.translator_api_configs_structure?.[
              formKey
            ]?.map((formField) => {
              // console.log({"formField": formField.unique});
              return createForm({
                name: formField.name,
                required: formField.required == "required" ? true : false,
                field_name: formField.field_name,
                showValidationIcons:
                  formField.required == "required" ? true : false,
                text: formField.text,
                field_type: formField.field_type,
                type:
                  formField.field_type == "password" ||
                  formField.name == "token" ||
                  formField.name == "client_secret"
                    ? "password"
                    : formField.date === "1" || formField.date === 1
                    ? "date"
                    : "text",
                unique: formField.unique,
                ...(formField.unique == "unique"
                  ? {
                      validators: [
                        createValidator({
                          name: "duplicate",
                          validatorFn: (value) => {
                            // console.log({ "Unique formData": formData, value });
                            const duplicates = formData.filter(
                              (formDataRow) =>
                                formDataRow[formField.name] == value
                            );
                            // console.log({
                            //   duplicates: duplicates,
                            //   formData,
                            //   value,
                            //   formField,
                            // });
                            if (duplicates?.length > 1) {
                              return false;
                            } else {
                              return true;
                            }
                          },
                          errorMessage: `Duplicate ${formField.name} Exists`,
                        }),
                      ],
                    }
                  : {}),
                ...(formField.field_type == "list"
                  ? {
                      options: createTV(
                        this.labelSettingsData?.[formField?.list_name],
                        // There were no Proper Dropdown Text Key in the Form Object, But there is a Value Text Key
                        // So this hack of slicing the last *id* part of the value key and replacing that with *name*
                        // Works well for almost all the cases
                        `${formField.name.slice(0, -2)}name`,
                        formField.name
                      ),
                    }
                  : {}),
              });
            }),
            formData,
          };
        });
      console.log({ aForms: aForms });
      return aForms;
    },
    nonEmptyApiForms: function () {
      return this.apiForms.filter((e) => {
        return e.formData?.length > 0;
      });
    },
    apiFormsSplitLength() {
      // console.log({
      //   "Math.floor(this.nonEmptyApiForms.length / 2 + 1)": Math.floor(
      //     this.nonEmptyApiForms.length / 2 + 1
      //   ),
      // });
      return this.nonEmptyApiForms.length > 2
        ? Math.ceil(this.nonEmptyApiForms.length / 2)
        : 1;
    },
  },
  methods: {
    dHeaders: dHeaders,
    ...mapActionObject(storeNS, labelSettingsActions),
    fetchData: function () {
      this[ActionTypes.LabelSettingsData.FETCH.ALL]();
    },
    tabSelectedRouting: function (tabId) {
      this.$router.push({
        name: "settings_label_tab",
        params: {
          tab: tabId,
        },
      });
    },

    // Format Methods
    onFormatAddClick: function (e) {
      openModalRoute(this, "format_form", {
        mode: "add",
      });
    },
    formatSubmitted: async function ({ mode, format }) {
      console.log(mode, format);
      if (mode === "add") {
        await this[ActionTypes.Formats.INSERT.SINGLE](format);
        this.onModalCancelled();
      } else if (mode === "edit") {
        await this[ActionTypes.Formats.SET.SINGLE](format);
        this.onModalCancelled();
      }
    },
    onFormatChange: function (payload) {
      this[ActionTypes.Formats.UPDATE.SINGLE](payload);
    },
    onFormatSelect: function (item) {
      openModalRoute(this, "format_form", {
        mode: "edit",
        format_id: item.format_id,
      });
    },
    onFormatDelete: async function (item) {
      const confirmationResult = await confirmDelete(
        "Format",
        item.format_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.Formats.DELETE.SINGLE](item);
      }
    },

    //Product Type Methods
    onProductTypeAddClick: function () {
      openModalRoute(this, "product_type_form", {
        mode: "add",
      });
    },
    productTypeSubmitted: async function ({ mode, product_type }) {
      if (mode === "add") {
        await this[ActionTypes.ProductTypes.INSERT.SINGLE](product_type);
        this.onModalCancelled();
      } else if (mode == "edit") {
        await this[ActionTypes.ProductTypes.UPDATE.SINGLE](product_type);
        this.onModalCancelled();
      }
    },
    onProductTypeDelete: async function (item) {
      const confirmationResult = await confirmDelete(
        "Product Type",
        item.product_type_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.ProductTypes.DELETE.SINGLE](item);
      }
      // const confirmationResult = await ConfirmationService.createP({
      //   subject: "Are you sure you want to delete the Product Type?",
      // });
      // if (confirmationResult == "OK") {
      //   this[ActionTypes.ProductTypes.DELETE.SINGLE](item);
      // }
    },
    onProductTypeClick: function (item) {
      openModalRoute(this, "product_type_form", {
        mode: "edit",
        product_type_id: item.product_type_id,
      });
    },

    //Price List Methods
    onPriceListAddClick: function () {
      openModalRoute(this, "price_list_form", {
        mode: "add",
      });
    },
    priceListSubmitted: async function ({ mode, price_list }) {
      console.log({ mode, price_list });
      if (mode === "add") {
        await this[ActionTypes.PriceLists.INSERT.SINGLE](price_list);
        this.onModalCancelled();
      } else if (mode == "edit") {
        await this[ActionTypes.PriceLists.UPDATE.SINGLE](price_list);
        this.onModalCancelled();
      }
    },
    onPriceListChange: function () {},
    onPriceListSelect: function (item) {
      console.log(item);
      openModalRoute(this, "price_list_form", {
        mode: "edit",
        price_list_id: item.price_list_id,
      });
    },
    onPriceListDelete: async function (item) {
      const confirmationResult = await confirmDelete(
        "Price List",
        item.price_list_name
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.PriceLists.DELETE.SINGLE](item);
      }
    },

    //Media type Methods
    onMediaTypeAddClick: function () {
      openModalRoute(this, "media_type_form", {
        mode: "add",
      });
    },
    onMediaTypeSubmit: async function ({ mode, media }) {
      if (mode == "add") {
        await this[ActionTypes.MediaTypes.INSERT.SINGLE](media);
        this.onModalCancelled();
      } else if (mode == "edit") {
        await this[ActionTypes.MediaTypes.UPDATE.SINGLE](media);
        this.onModalCancelled();
      }
    },
    onMediaTypeSelect: function (item) {
      console.log(item.media_id);
      openModalRoute(this, "media_type_form", {
        mode: "edit",
        media_id: item.media_id,
      });
    },
    onMediaTypeDelete: async function (item) {
      const confirmationResult = await confirmDelete(
        "Media Type",
        item.mechanical_name
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.MediaTypes.DELETE.SINGLE](item);
      }
    },

    //Price Code Methods
    onPriceCodeAddClick: function () {
      openModalRoute(this, "price_code_form", {
        mode: "add",
      });
    },
    onPriceCodeSubmit: async function ({ mode, price_code }) {
      console.log({ mode, price_code });
      if (mode == "add") {
        await this[ActionTypes.PriceCodes.INSERT.SINGLE](price_code);
        this.onModalCancelled();
      } else if (mode == "edit") {
        await this[ActionTypes.PriceCodes.UPDATE.SINGLE](price_code);
        this.onModalCancelled();
      }
    },
    onPriceCodeSelect: function (item) {
      openModalRoute(this, "price_code_form", {
        mode: "edit",
        price_code_id: item.price_code_id,
      });
    },
    onPriceCodeDelete: async function (item) {
      const confirmationResult = await confirmDelete(
        "Price Code",
        item.price_code_name
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.PriceCodes.DELETE.SINGLE](item);
      }
    },

    // Licence Status Methods
    onAddLicenceAccount: function () {
      openModalRoute(this, "add_licence_status");
    },
    onNewLicenceStatusAdded: function (value) {
      if (value) {
        this[ActionTypes.LicenceStatus.INSERT.SINGLE]({
          licence_status_text: value,
        });
      }
      this.onModalCancelled();
    },
    onLicenceStatusEdited: function (value) {
      this[ActionTypes.LicenceStatus.UPDATE.SINGLE]({
        licence_status_text: value,
        licence_status_id: this.$route.query.licence_status_id,
      });
      this.onModalCancelled();
    },
    onLicenceStatusDelete: async function (item) {
      const confirmationResult = await confirmDelete(
        "Licence",
        item.licence_status_text
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.LicenceStatus.DELETE.SINGLE](item);
      }
    },
    onLicenceStatusClick: function (item) {
      const { licence_status_text, licence_status_id } = item;
      openModalRoute(this, "edit_licence_status", {
        licence_status_text,
        licence_status_id,
      });
    },
    // Marketting Type Methods
    onMarketingTypeAddClick: function () {
      this[ActionTypes.MarketingTypes.INSERT.SINGLE]();
    },
    onMarketingTypeChange: function ({ name, value, item }) {
      this[ActionTypes.MarketingTypes.UPDATE.SINGLE]({ name, value, item });
    },
    onMarketingTypeSelect: function () {},
    onMarketingTypeDelete: async function (item) {
      if (!isNegative(item.marketing_type_id)) {
        const confirmationResult = await confirmDelete(
          "Marketing Type",
          item.marketing_type_name
        );
        if (confirmationResult == "OK") {
          this[ActionTypes.MarketingTypes.DELETE.SINGLE]({ item });
        }
      } else {
        this[ActionTypes.MarketingTypes.DELETE.SINGLE]({ item });
      }
    },

    onModalCancelled: function () {
      closeModalRoute(this, {
        mode: undefined,
        format_id: undefined,
        product_type_id: undefined,
        price_list_id: undefined,
        media_id: undefined,
        price_code_id: undefined,
        licence_status_id: undefined,
        licence_status_text: undefined,
        deal_type_id: undefined,
        deal_type_name: undefined,
        deal_type_code: undefined,
        advance_type_name: undefined,
        advance_type_id: undefined,

        label_status_id: undefined,

        shipping_type_id: undefined,
        shipping_type: undefined,
        service_code: undefined,

        // API Config Routes
        form_name: undefined,
      });
    },

    // API Config Methods
    onAPIConfigChange: function (payload) {
      this[ActionTypes.APIConfig.UPDATE.ALL](payload);
    },
    onAPIConfigAddClick: function () {
      openModalRoute(this, "add_config");
    },
    onAPIAdd: function (payload) {
      this[ActionTypes.APIConfig.INSERT.SINGLE](payload);
      this.onModalCancelled();
    },
    onAPIDeleted: async function (payload) {
      const { form_name, item } = payload;

      const key =
        this.labelSettingsData.translator_api_configs_structure[form_name][0]
          .name;
      const value = item[key];
      console.log(item);

      const confirmationResult = await confirmDelete(
        "API Config",
        ` ${form_name} ${snakeCaseToWords(key)} : ${value}`
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.APIConfig.DELETE.SINGLE](payload);
      }
    },

    // Deal Type Methods
    onDealTypeAddClick: function () {
      openModalRoute(this, "add_deal_type");
    },
    onDealTypeChange: function () {},
    onDealTypeSelected: function (item) {
      const { deal_type_id, deal_type_name, deal_type_code } = item;
      openModalRoute(this, "edit_deal_type", {
        deal_type_id,
        deal_type_name,
        deal_type_code,
      });
    },
    onDealTypeDeleted: async function (item) {
      const confirmationResult = await confirmDelete(
        "Deal Type",
        item.deal_type_name
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.DealTypes.DELETE.SINGLE](item);
      }
    },
    onNewDealTypeAdded: function (payload) {
      this[ActionTypes.DealTypes.INSERT.SINGLE](payload);
      this.onModalCancelled();
    },
    onDealTypeEdited: function (payload) {
      this[ActionTypes.DealTypes.UPDATE.SINGLE](payload);
      this.onModalCancelled();
    },
    onAdvanceTypeAddClick: function () {
      openModalRoute(this, "add_advance_type");
    },
    onAdvanceTypeClick: function ({ advance_type_id, advance_type_name }) {
      openModalRoute(this, "edit_advance_type", {
        advance_type_id,
        advance_type_name,
      });
    },
    onAdvanceTypeDelete: async function (item) {
      const confirmationResult = await confirmDelete(
        "Advance Type",
        item.advance_type_name
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.AdvanceType.DELETE.SINGLE](item);
      }
    },
    onNewAdvanceTypeAdd: function (value) {
      if (value) {
        this[ActionTypes.AdvanceType.INSERT.SINGLE]({
          advance_type_name: value,
        });
      }
      this.onModalCancelled();
    },
    onAdvanceTypeEdit: function (value) {
      this[ActionTypes.AdvanceType.UPDATE.SINGLE]({
        advance_type_name: value,
        advance_type_id: this.advance_type_id,
      });
      this.onModalCancelled();
    },

    onColorChange: function (label_status) {
      this[ActionTypes.LabelStatus.UPDATE.SINGLE](label_status);
    },
    onLabelStatusDeleteClick: function (label_status_id) {
      this[ActionTypes.LabelStatus.DELETE.SINGLE](label_status_id);
    },
    onLabelStatusAddClick: function () {
      openModalRoute(this, "add_status");
    },
    async onLabelStatusAdded(labelStatus) {
      await this[ActionTypes.LabelStatus.INSERT.SINGLE](labelStatus);
      this.onModalCancelled();
    },
    onLabelStatusEdited(labelStatus) {
      this[ActionTypes.LabelStatus.UPDATE.SINGLE](labelStatus);
      this.onModalCancelled();
    },

    async onShippingTypeAdded(payload) {
      await this[ActionTypes.ShippingType.INSERT.SINGLE]({
        ...payload,
        shipping_type_id: "",
      });
      this.onModalCancelled();
    },
    async onShippingTypeEdited(payload) {
      await this[ActionTypes.ShippingType.UPDATE.SINGLE](payload);
      this.onModalCancelled();
    },
    async onShippingTypeDelete(payload) {
      this[ActionTypes.ShippingType.DELETE.SINGLE](payload);
    },

    onMechanicalRateAdd: async function () {
      await this[ActionTypes.MechanicalRate.INSERT.SINGLE]();
    },
    onMechanicalRateChange: async function (payload) {
      await this[ActionTypes.MechanicalRate.UPDATE.SINGLE](payload);
    },
    onMechanicalRateDelete: async function (item) {
      this[ActionTypes.MechanicalRate.DELETE.SINGLE](item.mechanical_rate_id);
    },

    // API Config Methods
    snakeCaseToWords: snakeCaseToWords,
    onDynamicFormChange: async function (payload) {
      this[ActionTypes.APIConfig.UPDATE.ALL](payload);

      if (!this.isFormValid()) {
        showError("Provide all the mandatory Fields");
      }
      await wait(2000);
      showNotification("API Config Updated");
    },
    onDropdownChange: function (name, value) {},
    onSave: function () {},
    onAddFormItemClick: function (form_name) {
      openModalRoute(this, "add_config", {
        form_name,
      });
    },
    onDNValidated: function ({ name, value, form_name, index }) {
      this.formValidation = set(
        lensPath([form_name, index, name]),
        value,
        this.formValidation
      );
    },
    splitEvery: splitEvery,
    isFormValid: function () {
      const temp2 = this.formValidation;
      const flatValidationObj = fromPairs(
        toPairs(temp2)
          .map(([f, v1]) =>
            toPairs(v1).map(([i, v2]) =>
              toPairs(v2).map(([n, v3]) => [`${f}_${i}_${n}`, v3])
            )
          )
          .flat(2)
      );
      return Object.keys(flatValidationObj)
        .filter((key) => flatValidationObj[key])
        .map((key) => flatValidationObj[key].valid)
        .every((e) => e);
    },
    onDeleteAPIItem: async function (payload) {
      const { form_name, item } = payload;

      const key =
        this.labelSettingsData.translator_api_configs_structure?.[
          form_name
        ]?.[0].name;
      const value = item[key];
      console.log(item);

      const confirmationResult = await confirmDelete(
        "API Config",
        ` ${form_name} ${snakeCaseToWords(key)} : ${value}`
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.APIConfig.DELETE.SINGLE](payload);
      }
    },
    onMinimizeAPIItem: function (form_name, index) {
      if (this.isMinimized(form_name, index)) {
        this.minimizedFormItems = this.minimizedFormItems.filter(
          (f) => !(form_name == f[0] && index == f[1])
        );
      } else {
        this.minimizedFormItems = [
          ...this.minimizedFormItems,
          [form_name, index],
        ];
      }
      console.log({ "form_name, index": form_name, index });
      console.log({ "this.minimizedFormItems": this.minimizedFormItems });
    },
    isMinimized(form_name, index) {
      return this.minimizedFormItems.find(
        (f) => form_name == f[0] && index == f[1]
      );
    },
    maximizedHeight(apiForm, index) {
      if (apiForm.formData?.length - 1 == index) {
        return `${apiForm.form.length * 32 + 2}px`;
      } else {
        return `${(apiForm.form.length + 1) * 32 + 2}px`;
      }
    },
    onAddAPIConfigClick() {
      openModalRoute(this, "add_config");
    },
    onTemplateTaskGroupAddClick: function (payload) {
      openModalRoute(this, "add_task_template_group", {
        external_table: payload,
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-label-settings {
  background: white;
  padding: 8px;

  .dt-grid-layout {
    height: calc(100vh - 108px);
  }
  // .grids-page {
  //   height: calc(100vh - 112px) !important;
  // }

  .invoice-notifications {
    .dt-checkbox-control {
      padding-top: 10px;
      padding-left: 3px;
      .dt-checkbox {
        max-width: 40px;
        margin-right: 10px;
        margin-top: 5px;
      }
      .dt-checkbox-label {
        flex: 1;
      }
    }
  }

  .api-item {
    &:not(:first-child) {
      border-top: 1px solid var(--sprt-75);
    }
    &:not(:last-child) {
      /* background: gainsboro; */
      & > .api-item-form {
        /* background: forestgreen; */
        /* padding-bottom: 32px; */
      }
    }
    &.minimized:not(:last-child) {
      .api-item-title-bar {
        border-bottom: none;
      }
    }
    .api-item-title-bar {
      border-bottom: 1px solid var(--sprt-85);

      .api-options {
        .dt-icon-container:first-child {
          border-left: 1px solid var(--sprt-85);
        }
        .dt-icon-container:not(:last-child) {
          border-right: 1px solid var(--sprt-85);
        }
      }
    }
  }
  .api-item-form {
  }
}
</style>
